import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  addProjectExternalLink(
    request: Boundaries["addProjectExternalLink"]["request"],
  ): void;
}

function useAddProjectExternalLink(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isAddProjectExternalLinkRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isAddProjectExternalLinkRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isAddProjectExternalLinkRequestFailure,
    ),
    addProjectExternalLink: core.addProjectExternalLink,
  };
}

export { useAddProjectExternalLink };
